/* eslint-disable no-console */
import travellaHeader from "../TravellaHeader";
import SettingsService from "../../shared/settings/settings.service.js";
import AuthService from "../../shared/auth/auth.service.js";
import 'primevue/resources/themes/nova-light/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

export default {
    name: "TabelaObrotow",
    data: function () {
        return {
            zamowienieId: Number,
            daneWspolpracownikow: {
                Wspolpracownicy: Array
            },
            czyModalZmianyPrzypisanegoUzytkownika: false,
            idUslugi: Number,
            brakDanychDlaUslug: 1,
            pracownicy: [],
            mozliwiPracownicy: Array,
            wybranyPracownik: String,
            loginyWspolpracownikow: [],
            daneZamowienia: [],
            daneZalogowanegoUzytkownika: Array,
            premiaEdytowalnaDlaUzytkownika: [],
            loginyModyfikujace: [],
            renderKey: 0,
            wTrakcieLadowania: 0
        };
    },
    methods: {
        zmianaPracownika(numerUslugi) {
            this.wybranyPracownik = this.mozliwiPracownicy[numerUslugi];
            this.idUslugi = this.daneZamowienia[numerUslugi].ID;
            this.czyModalZmianyPrzypisanegoUzytkownika = true;
        },
        pobierzDaneZamowienia() {
            this.ladowanieDanychWidoku();
            this.$http
                .get(
                    `${SettingsService.apiUrl}/premie-miesieczne-api/premia-miesieczna/${this.zamowienieId}/lista`
                )
                .then(response => {
                    this.brakDanychDlaUslug = false;
                    this.daneWspolpracownikow.Wspolpracownicy = response.body.Uzytkownicy;
                    this.wypelnijTablicePracownikowILoginow();
                    this.daneZamowienia = [...response.body.DaneZamowienia];
                    this.sprawdzPowiazaniaUzytkownikowZUslugami();
                })
                .catch(error => {
                    console.error(error);
                    this.brakDanychDlaUslug = true;
                });
        },
        wypelnijTablicePracownikowILoginow() {
            this.pracownicy = this.pracownicy.concat(
                this.daneWspolpracownikow.Wspolpracownicy
            );
            this.loginyWspolpracownikow = this.loginyWspolpracownikow.concat(
                this.daneWspolpracownikow.Wspolpracownicy.map(x => x.Login)
            );
        },
        sprawdzPowiazaniaUzytkownikowZUslugami() {
            AuthService.getProfile().then(data => {
                this.sprawdzCzyMogeEdytowacUslugi(data);
            });
        },
        sprawdzCzyMogeEdytowacUslugi(daneZalogowanegoUzytkownika) {
            this.premiaEdytowalnaDlaUzytkownika = this.daneZamowienia.map(
                x => x.ModyfikujacyUzytkownikId == daneZalogowanegoUzytkownika.sub
            );

            this.pracownicy.push({
                Login: daneZalogowanegoUzytkownika.name,
                idUzytkownika: daneZalogowanegoUzytkownika.sub
            });

            this.przypiszLoginyDoNazwUzytkownikow();
            this.renderKey += 1;
        },
        przypiszLoginyDoNazwUzytkownikow() {
            for (let l = 0; l < this.daneZamowienia.length; l++) {
                const p = this.pracownicy.filter(
                    x =>
                        this.daneZamowienia[l].ModyfikujacyUzytkownikId == x.idUzytkownika
                )[0];
                this.loginyModyfikujace[l] = p ? p.Login : "Login Spoza Twojej Grupy";
            }
        },
        zmienUzytkownika(uzytkownikId) {
            this.$http.post(
                `${SettingsService.apiUrl}/premie-miesieczne-api/premia-miesieczna/${this.idUslugi}/${uzytkownikId}`
            ).then(() => {
                this.pobierzDaneZamowienia();
            })
            this.renderKey += 1;
        },
        zamknijModal() {
            this.czyModalZmianyPrzypisanegoUzytkownika = false;
        },
        zmianaPracownikaPrzypisanegoDoUslugi() {
            this.zamknijModal();

            const szukanyUzytkownik = this.daneWspolpracownikow.Wspolpracownicy.filter(
                x => x.Login === this.wybranyPracownik
            )[0];
            this.idUzytkownika = szukanyUzytkownik.UzytkownikId;
            this.zmienUzytkownika(this.idUzytkownika);
        },
        ladowanieDanychWidoku() {
            this.$nextTick(function () {
                this.wTrakcieLadowania = !this.wTrakcieLadowania;
                this.renderKey += 1;
            });
        }
    },
    mounted: function () {
        travellaHeader.loadHeader();
        this.zamowienieId = this.$route.query.zamowienieId;
        this.pobierzDaneZamowienia();
    }
};